import { CaretDown } from "@phosphor-icons/react"
import { Button } from "@/components/ui/button"
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu"
import { ScrollArea } from "@/components/ui/scroll-area"
import { EpisodeOfCareNavigation } from "@/modules/patients/detail/episode-of-care/episode-of-care-nav"
import { chPatientEpisodesOfCareQuery$data } from "@/modules/patients/services/ch/__generated__/chPatientEpisodesOfCareQuery.graphql"
import { dePatientEpisodesOfCareQuery$data } from "@/modules/patients/services/de/__generated__/dePatientEpisodesOfCareQuery.graphql"

interface EpisodeOfCareNavigationDropdownProps {
  patientId: string
  patientEpisodesOfCareRef: dePatientEpisodesOfCareQuery$data & chPatientEpisodesOfCareQuery$data
  appointmentId: string | null
  isEditMode: boolean
}

const EpisodeOfCareNavigationDropdown = ({
  patientEpisodesOfCareRef,
  appointmentId,
  patientId,
  isEditMode,
}: EpisodeOfCareNavigationDropdownProps) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="circle" className="@xxl:hidden h-10 w-10 shrink-0 p-1 @xs:flex">
          <CaretDown size={20} className="text-on-surface-subdued shrink-0" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="bg-surface shadow-4 absolute top-full left-0 z-10 box-border min-w-[288px] origin-top-left scale-100 transform rounded-xl focus-visible:outline-hidden"
        align="start">
        <ScrollArea>
          <div className="max-h-75">
            <DropdownMenuItem className="block p-2">
              <EpisodeOfCareNavigation
                patientEpisodesOfCareRef={patientEpisodesOfCareRef}
                appointmentId={appointmentId}
                patientId={patientId}
                isEditMode={isEditMode}
                isDropdown={true}
              />
            </DropdownMenuItem>
          </div>
        </ScrollArea>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export { EpisodeOfCareNavigationDropdown }
